import React from 'react';
import { detectBrandFromHost, getBrandInfo } from '@/lib/brand-utils';

export type BrandLogoProps = {
  className?: string;
  alt?: string;
};

export default function BrandLogo({
  className = 'h-10 w-auto',
  alt = 'Membership brand',
}: BrandLogoProps) {
  const brand = detectBrandFromHost();
  const info = getBrandInfo(brand);
  return <img src={info.logoUrl} alt={alt || info.name} className={className} />;
}
